import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import GetInvolvedHero from './components/GetInvolvedHero';
import WaysToGive from './components/WaysToGive';
import GetInvolvedForm from './components/GetInvolvedForm';

export default function GetInvolvedPage() {
  return (
    <main>
      <Navbar />
      <GetInvolvedHero />
      <WaysToGive />
      <GetInvolvedForm />
      <Footer />
    </main>
  );
}
